import { MdFormatSize } from "react-icons/md";
import { useAccessibility } from "../../../context/AccessibilityContext";

const SIZES = [
  { key: "small",  label: "A−",  name: "Pequeno",      px: 14 },
  { key: "normal", label: "A",   name: "Normal",       px: 16 },
  { key: "large",  label: "A+",  name: "Grande",       px: 18 },
  { key: "xlarge", label: "A++", name: "Extra Grande", px: 22 },
];

const TextResize = () => {
  const { settings, updateSetting } = useAccessibility();
  const current = SIZES.find((s) => s.key === settings.fontSize) ?? SIZES[1];

  return (
    <div className="p-8 max-w-2xl space-y-6">
      <div className="flex items-center gap-3">
        <MdFormatSize className="text-4xl text-blue-900 flex-shrink-0" />
        <div>
          <h2 className="text-xl font-bold text-blue-950">Redimensionamento de Texto</h2>
          <p className="text-sm text-gray-500 mt-0.5">
            Ajuste o tamanho do texto em todo o portal para melhor legibilidade.
          </p>
        </div>
      </div>

      {/* Selector */}
      <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 space-y-4">
        <p className="font-semibold text-blue-950 text-sm">Escolha o tamanho do texto</p>
        <div className="grid grid-cols-4 gap-3">
          {SIZES.map(({ key, label, name, px }) => (
            <button
              key={key}
              onClick={() => updateSetting("fontSize", key)}
              aria-pressed={settings.fontSize === key}
              aria-label={name}
              className={`flex flex-col items-center gap-1 py-4 rounded-xl border-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                settings.fontSize === key
                  ? "border-blue-600 bg-blue-600 text-white shadow-sm"
                  : "border-gray-200 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-50"
              }`}
            >
              <span className="font-bold" style={{ fontSize: px }}>{label}</span>
              <span className="text-xs font-medium opacity-80">{name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Live preview */}
      <div>
        <p className="text-xs text-gray-400 uppercase font-semibold tracking-wider mb-3">
          Pré-visualização — {current.name}
        </p>
        <div className="rounded-2xl border border-gray-200 bg-white p-6 space-y-3" style={{ fontSize: current.px }}>
          <p className="font-bold text-blue-950" style={{ fontSize: current.px * 1.25 }}>
            Prefeitura Municipal de Serrinha
          </p>
          <p className="text-gray-600 leading-relaxed">
            Portal oficial com informações sobre serviços, notícias e transparência pública para todos os cidadãos do município.
          </p>
          <div className="flex gap-2 flex-wrap">
            <span className="inline-block bg-blue-100 text-blue-900 rounded-full px-3 py-1 font-medium" style={{ fontSize: current.px * 0.75 }}>
              Transparência
            </span>
            <span className="inline-block bg-gray-100 text-gray-700 rounded-full px-3 py-1 font-medium" style={{ fontSize: current.px * 0.75 }}>
              Serviços
            </span>
            <span className="inline-block bg-yellow-100 text-yellow-900 rounded-full px-3 py-1 font-medium" style={{ fontSize: current.px * 0.75 }}>
              Notícias
            </span>
          </div>
        </div>
      </div>

      {/* Status */}
      <div
        className={`flex items-center gap-3 p-4 rounded-xl text-sm font-medium ${
          settings.fontSize !== "normal"
            ? "bg-blue-600 text-white"
            : "bg-gray-100 text-gray-600"
        }`}
      >
        <MdFormatSize className="text-xl flex-shrink-0" />
        <span>
          Tamanho atual: <strong>{current.name}</strong>
          {settings.fontSize !== "normal" && " — configuração salva automaticamente."}
        </span>
      </div>
    </div>
  );
};

export default TextResize;
